import { BuildInstructionCollection } from './types';
import { KWH_01_01 } from './kwh-01-01';
import { getProductBySlug, getInternalProductId, parseUrl, getAllProducts } from './productMapping';

// Central registry of all build instructions (by internal ID)
export const BUILD_INSTRUCTIONS: BuildInstructionCollection = {
    'kwh-01-01': KWH_01_01,
    // Future products can be added here:
    // 'kwh-02-01': KWH_02_01,
    // 'kbt-01-01': KBT_01_01, // Kibu Bluetooth headphones
    // 'ksb-01-01': KSB_01_01, // Kibu Soundbar
};

// Default product for legacy routes
export const DEFAULT_BUILD_INSTRUCTION = 'kwh-01-01';

// Helper functions for internal ID access (legacy)
export const getBuildInstruction = (productId: string) => {
    return BUILD_INSTRUCTIONS[productId] || BUILD_INSTRUCTIONS[DEFAULT_BUILD_INSTRUCTION];
};

export const getAllBuildInstructions = () => {
    return Object.values(BUILD_INSTRUCTIONS);
};

export const getBuildInstructionIds = () => {
    return Object.keys(BUILD_INSTRUCTIONS);
};

// New helper functions for URL-based access
export const getBuildInstructionByUrl = (productSlug: string, version?: string) => {
    const internalId = getInternalProductId(productSlug, version);
    return internalId ? BUILD_INSTRUCTIONS[internalId] : undefined;
};

export const getProductInfo = (productSlug: string) => {
    return getProductBySlug(productSlug);
};

// Export the new URL utilities
export { parseUrl, getAllProducts, getProductBySlug, getInternalProductId };

// Export types for external use
export * from './types';
export * from './productMapping';